<template>
  <FinancialAdvisorProUpsellAnnualPlanCardSkeleton v-if="isLoading" />
  <section
    v-else
    class="has-border-light has-shadow has-border-radius p-5"
    :data-e2e="FinancialAdvisorEstateCypressAttribute.modal.views.ADVISOR_PRO_UPSELL_PRICING_CARD"
  >
    <p class="is-size-1 has-text-weight-semibold has-text-primary m-b-5">
      {{ $t('financialadvisor.pro-upsell-annual-plan-title') }}
    </p>
    <p class="is-size-1 has-text-weight-semibold m-b-5">
      {{ plan.formattedPrice }}
      <span class="is-size-3 has-text-secondary-grey">
        {{ $t('financialadvisor.pro-upsell-annual-plan-price-period') }}
      </span>
    </p>
    <p class="is-size-4 m-b-10">
      {{ $t('financialadvisor.pro-upsell-annual-plan-tax-note') }}
    </p>
    <section
      class="is-flex is-flex-direction-column has-background-light p-3 has-radius-large is-gap-1 m-b-10"
      :data-e2e="
        FinancialAdvisorEstateCypressAttribute.modal.views.ADVISOR_PRO_UPSELL_GUARANTEE_BADGE
      "
    >
      <div class="is-flex is-align-items-center">
        <i class="cls cls-shield-check-2 is-size-3 pr-2 has-text-success" aria-hidden="true"></i>
        <p class="has-text-weight-semibold">
          {{ $t('financialadvisor.guarantee-title') }}
        </p>
      </div>

      <p class="is-size-6">
        {{ $t('financialadvisor.guarantee-supporting-line') }}
      </p>
    </section>
    <ButtonView
      type="is-primary"
      class="p-4 is-full-width"
      :loading="isLoadingButton"
      @click="onGetPlan"
      :data-e2e="FinancialAdvisorEstateCypressAttribute.modal.buttons.GET_PLAN"
    >
      <span class="has-text-weight-semibold">
        {{ $t('financialadvisor.pro-upsell-annual-plan-cta') }}
      </span>
    </ButtonView>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { FinancialAdvisorEstateCypressAttribute } from '@/modules/financialadvisor/constants/FinancialAdvisorEstateCypressAttribute';
import { FinancialAdvisorProUpsellPlanMixin } from '@/modules/financialadvisor/mixins/FinancialAdvisorProUpsellPlanMixin';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import FinancialAdvisorProUpsellAnnualPlanCardSkeleton from '@/modules/financialadvisor/components/skeletons/FinancialAdvisorProUpsellAnnualPlanCardSkeleton.vue';

export default defineComponent({
  name: 'FinancialAdvisorProUpsellAnnualPlanCard',
  mixins: [FinancialAdvisorProUpsellPlanMixin],
  components: {
    ButtonView,
    FinancialAdvisorProUpsellAnnualPlanCardSkeleton
  },
  static: {
    FinancialAdvisorEstateCypressAttribute
  },
  data(): {
    isLoading: boolean;
  } {
    return {
      isLoading: true
    };
  },
  methods: {
    async loadPlanPrice(): Promise<void> {
      try {
        await this.plan.loadPlanPrice();
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted(): void {
    this.loadPlanPrice();
  }
});
</script>
